import { useState } from "react";
import { system_table } from "../../service/system";
import { decimalAddZero } from "../../service/common";

import { ColumnGroup } from "primereact/columngroup";
import { Column } from "primereact/column";
import { Row } from "primereact/row";

const useTable = ({ initData = [], initSize = system_table.size } = {}) => {
  const [rawTbData, setRawTbData] = useState(initData);
  const [tbData, setTbData] = useState(initData);
  const [tbTotalRecords, setTbTotalRecords] = useState(0);
  const [tbFirstIndex, setTbFirstIndex] = useState(0);
  const [tbRows, setTbRows] = useState(initSize);
  const [tbColumns, setTbColumns] = useState([]);
  const [tbFootGroup, setTbFootGroup] = useState(null);
  const [tbExpandRows, setTbExpandRows] = useState(null);
  const [pageAction, setPageAction] = useState(null);
  const [sortField, setSortField] = useState([]);

  const renderFooter = ({ item, footData, decimal }) => {
    if (footData[item.key] === undefined) return "";
    if (typeof footData[item.key] !== "number") return footData[item.key];

    return decimalAddZero({
      rawVal: footData[item.key],
      decimalCount: String(footData[item.key]).includes(".") ? decimal : 0,
    });
  };

  const createTbFooter = ({ headColumns, footData, decimal = 3 }) => {
    let temp = (
      <ColumnGroup>
        <Row>
          {headColumns.map((item) => (
            <Column
              key={item.key}
              footer={renderFooter({ item, footData, decimal })}
            />
          ))}
        </Row>
      </ColumnGroup>
    );

    setTbFootGroup(temp);
  };

  return {
    tbData,
    setTbData,
    rawTbData,
    setRawTbData,
    tbTotalRecords,
    setTbTotalRecords,
    tbFirstIndex,
    setTbFirstIndex,
    tbRows,
    setTbRows,
    tbColumns,
    setTbColumns,
    setTbFootGroup,
    tbExpandRows,
    setTbExpandRows,
    createTbFooter,
    pageAction,
    setPageAction,
    tbFootGroup,
    sortField,
    setSortField,
  };
};

export default useTable;
